/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Integrations_Zotero_DescriptionInputs */

const en_settings_integrations_zotero_description = /** @type {(inputs: Settings_Integrations_Zotero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import PDFs and documents from your Zotero library.`)
};

const es_settings_integrations_zotero_description = /** @type {(inputs: Settings_Integrations_Zotero_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa PDFs y documentos desde tu biblioteca de Zotero.`)
};

/**
* | output |
* | --- |
* | "Import PDFs and documents from your Zotero library." |
*
* @param {Settings_Integrations_Zotero_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_integrations_zotero_description = /** @type {((inputs?: Settings_Integrations_Zotero_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Integrations_Zotero_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_integrations_zotero_description(inputs)
	return en_settings_integrations_zotero_description(inputs)
});